import api from "./axiosConfig";
import localforage from "localforage";

const API_URL = process.env.REACT_APP_API_URL;

// Cached Zone -> PC -> AC hierarchy, derived on the backend from booth data.
// Shape: { [zone]: { [pc]: [ac, ...] } }
let _cache = null;

export async function fetchGeoHierarchy() {
  if (_cache) return _cache;
  try {
    const token = await localforage.getItem("token");
    const { data } = await api.get(`${API_URL}/mom-format/geo-hierarchy`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    _cache = data && typeof data === "object" ? data : {};
  } catch (e) {
    _cache = {};
  }
  return _cache;
}
